import React from "react";
import ReactDOM from "react-dom";

import BaseComponent from "../../../baseComponent";
import styles from "./styles.scss";
import TemplateParser from "../../../../core/utils/templateParser";
import ColorUtil from "../../../../core/utils/colorUtil";

const editIndicatorList = ["SMA", "MACD", "RSI", "FIBONACCI", "BOLLINGER BANDS"];

export default class TradingViewLegends extends BaseComponent {
  constructor(props) {
    super(props);
    const sma = this.getLegendByLabel("SMA");
    const macd = this.getLegendByLabel("MACD");
    const rsi = this.getLegendByLabel("RSI");
    const bb = this.getLegendByLabel("BOLLINGER BANDS");
    this.state = {
      showEdit: false,
      SMA: sma.parameters.indicatorInputs || this.props.defaultInputs("SMA"),
      MACD: macd.parameters.indicatorInputs || this.props.defaultInputs("MACD"),
      RSI: rsi.parameters.indicatorInputs || this.props.defaultInputs("RSI"),
      BB: bb.parameters.indicatorInputs || this.props.defaultInputs("BOLLINGER BANDS")
    }
  }

  getLegendByLabel(label) {
    return this.props.legends.find(l => l.parameters.legendLabel === label);
  }

  showEditDialog(id) {
    const element = document.getElementById(id);
    if (element) {
      element.style.display = 'block';
    }
  }

  hideEditDialog(id) {
    const element = document.getElementById(id);
    if (element) {
      element.style.display = 'none';
    }
  }

  handleInputChange(name, index, value, legend) {
    const state = {};
    const inputs = JSON.parse(JSON.stringify(this.state[name]));
    inputs[index] = value;
    state[name] = inputs;
    this.setState(state);
    this.props.indicatorInputChange(legend, inputs);
  }

  renderEditDialog(legend) {
    switch (legend.parameters.legendLabel) {
      case "SMA": {
        return <div className={styles.indicatorInputs}>
          <div style={{width: "140px"}}>Simple Moving Average</div>
          <div>
            <div>Period</div>
            <input type="number" value={this.state.SMA[0]}
                   onChange={e => this.handleInputChange("SMA", 0, e.target.value, legend)}/>
          </div>
        </div>;
      }
      case "MACD": {
        return <div className={styles.indicatorInputs}>
          <div style={{width: "240px"}}>Moving Average Convergence Divergence</div>
          <div>
            <div style={{width: "133px"}}>Fast Period (EMA)</div>
            <input type="number" value={this.state.MACD[0]}
                   onChange={e => this.handleInputChange("MACD", 0, e.target.value, legend)}/>
          </div>
          <div>
            <div style={{width: "133px"}}>Slow Period (EMA)</div>
            <input type="number" value={this.state.MACD[1]}
                   onChange={e => this.handleInputChange("MACD", 1, e.target.value, legend)}/>
          </div>
          <div>
            <div style={{width: "133px"}}>Signal Period (EMA)</div>
            <input type="number" value={this.state.MACD[3]}
                   onChange={e => this.handleInputChange("MACD", 3, e.target.value, legend)}/>
          </div>
        </div>;
      }
      case "RSI": {
        return <div className={styles.indicatorInputs}>
          <div style={{width: "140px"}}>Relative Strength Index</div>
          <div>
            <div>Period</div>
            <input type="number" value={this.state.RSI[0]}
                   onChange={e => this.handleInputChange("RSI", 0, e.target.value, legend)}/>
          </div>
        </div>;
      }
      case "BOLLINGER BANDS": {
        return <div className={styles.indicatorInputs}>
          <div>Bollinger Band</div>
          <div>
            <div>Period</div>
            <input type="number" value={this.state.BB[0]}
                   onChange={e => this.handleInputChange("BB", 0, e.target.value, legend)}/>
          </div>
          <div>
            <div>StdDev</div>
            <input type="number" value={this.state.BB[1]}
                   onChange={e => this.handleInputChange("BB", 1, e.target.value, legend)}/>
          </div>
        </div>;
      }
      case "FIBONACCI": {
        return <div className={styles.indicatorInputs}>
          <div style={{width: "134px"}}>Fibonacci Retracement</div>
        </div>;
      }
    }
  }

  renderLegend(legend) {
    let opacity = 1;
    let bgColor = ColorUtil.toRgba(legend.parameters.legendColor, legend.parameters.chartTypeParameters.fillOpacity);
    let borderColor = legend.parameters.legendColor
    if (!legend.parameters.isActive) {
      opacity = 0.5;
      bgColor = "#fff";
      borderColor = "grey";
    }
    return <div className={styles.legend} key={legend.id}
                onMouseEnter={() => this.showEditDialog(`legendEditDialog-${legend.id}`)}
                onMouseLeave={() => this.hideEditDialog(`legendEditDialog-${legend.id}`)}>
      <div className={styles.legendCircle}
           onClick={() => this.props.legendClick(legend.id)}
           style={{background: bgColor, borderColor, opacity}}/>
      <div className={styles.legendLabel}
           style={{opacity}}
           onClick={() => this.props.legendClick(legend.id)}>
        {TemplateParser.parseTemplate(legend.parameters.legendLabel)}
      </div>
      {editIndicatorList.indexOf(legend.parameters.legendLabel) > -1 ?
        <div className={styles.legendEditDialog} id={`legendEditDialog-${legend.id}`}>
          {this.renderEditDialog(legend)}
        </div> : null
      }
    </div>
  }

  render() {
    return (
      <div className={styles.legendsContainer} ref="legendContainer">
        {this.props.legends.map(l => this.renderLegend(l))}
        <div className={styles.legendEditBackdrop}
             style={{display: this.state.showEdit ? "block" : "none"}} onClick={this.hideEditDialog}>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/trading-view/legends.jsx